import { useContext } from 'react';

/* Modal */
import ActionModal from '@/components/game/ui/modal/ActionModal';
import AdminStateModal from '@/components/game/ui/modal/AdminStateModal';
import CardsOnTableModal from '@/components/game/ui/modal/cards/CardsOnTableModal';
import HandModal from '@/components/game/ui/modal/cards/HandModal';
import NewsCardsModal from '@/components/game/ui/modal/cards/NewsCardsModal';
import DecisionCardResolutionServerModal from '@/components/game/ui/modal/decision/DecisionCardResolutionServerModal';
import DecisionModal from '@/components/game/ui/modal/decision/DecisionModal';
import DecisionSummitDraftModal from '@/components/game/ui/modal/decision/DecisionSummitDraftModal';
import DecisionSummitWinterModal from '@/components/game/ui/modal/decision/DecisionSummitWinterModal';
import DecisionTurnOrderModal from '@/components/game/ui/modal/decision/DecisionTurnOrderModal';
import PaymentAnimatedModal from '@/components/game/ui/modal/PaymentAnimatedModal';
// import PaymentModal from '@/components/game/ui/modal/PaymentModal';
import SettingsModal from '@/components/game/ui/modal/SettingsModal';
import PlayermatModal from '@/components/game/ui/modal/static/PlayermatModal';
import RulesmatModal from '@/components/game/ui/modal/static/RulesmatModal';
import { GameContext, ViewContext } from '@/state/contexts';
import { logg } from '@/util/logg';
import {
	decisionSummitDraft,
	decisionTurnOrder,
	decisionCardResolution,
	decisionSummitWinter,
} from '@lc/const/turnTypes';

import DiscardCardFromHandModal from './cards/DiscardCardFromHandModal';
//import DiscardPile from './cards/DiscardPileModal';
import DiscardPileModal from './cards/DiscardPileModal';

const ModalContainer = () => {
	const {
		currPlayer,
		players,
		myState,

		activePlayerId,
		turnType,

		setPaymentObject,

		setPaymentTotal,

		selectedAction,

		// playerStateArray,
		// singlePlayer,

		// gameStatus,

		// paymentObject,
		// paymentTotal,

		// setSelectedAction,
		// setSelectedActionCost,
		// selectedActionCost,
		// selectedCard,
		// selectedCardId, // TODO selectedCard will determine price, source and target, decisions. Replace w/ cardId

		// setSourceId,
		// sourceId,
		// setTargetId,
		// targetId,
		// setChoiceInt,
		// choiceInt,
	}: any = useContext(GameContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,

	const {
		showHandModal,
		setShowHandModal,

		showDiscardCardFromHandModal,
		setShowDiscardCardFromHandModal,

		showPaymentModal,
		setShowPaymentModal,

		showCardTableModal,

		cardsOnTablePlayerId,

		showNewsCardsModal,

		showDecisionModal,
		setShowDecisionModal,

		minimize,

		playerMatPath,

		showPlayermatModal,
		setShowPlayermatModal,

		showRulesmatModal,
		setShowRulesmatModal,

		showAdminStateModal,
		setShowAdminStateModal,

		showActionModal,
		setShowActionModal,

		showSettingsModal,
		setShowSettingsModal,

		showDiscardPileModal,
		setShowDiscardPileModal,

		// recyclingCardId,
		setRecyclingCardId,

		// pPE,
		// pPC,

		// toggleMinimize,
		viewNewsCards,

		// clientAction,
		equipmentAction,
		closeCardTable,

		// setShowCardTableModal,
		// setCardsOnTablePlayerId,
		// setShowNewsCardsModal,
		// setMinimize,
		// setPlayerMatPath,
		// showACA,
		// setShowACA,
		// showCCA,
		// setShowCCA,
		// showFC,
		// setShowFC,
		// showEquipment,
		// setShowEquipment,

		// camState,
		// changeCamera,

		// showTicker,
		// setShowTicker,

		// backgroundEffects,
		// setBackgroundEffects,
	}: any = useContext(ViewContext);

	let selectedActionVar = '';

	const closeDecision = () => {
		setShowDecisionModal(false);
	};

	const closeActionModal = () => {
		setShowActionModal(false);
	};

	const closeSettingsModal = () => {
		setShowSettingsModal(false);
	};

	const closeHand = () => {
		setShowHandModal(false);
		// setRecyclingCardId(-1);
		// setIsRecycling(false);
	};

	const closeDiscardCardFromHandModal = () => {
		setShowDiscardCardFromHandModal(false);
		setRecyclingCardId(-1);
	};

	const closePayment = () => {
		setShowPaymentModal(false);
	};

	function closePlayermat() {
		setShowPlayermatModal(false);
	}

	function closeRulesmat() {
		setShowRulesmatModal(false);
	}

	function closeAdminState() {
		setShowAdminStateModal(false);
	}

	function requestClientDecision() {
		closeHand();
		closePayment();
		requestDecisionForCard();
	}

	function requestClientPayment() {
		logg('action selected');
		logg(selectedAction);
		logg(selectedActionVar);
		closeHand();
		showPayment();
	}

	const requestDecisionForCard = () => {
		setShowPaymentModal(false);
		setShowDecisionModal(true);
	};

	function resetPaymentObject() {
		// get player state from hooks
		setPaymentObject({
			factoryEnergyArr: [],
			batteryEnergyArr: [],
			carbonReserve: 0,
		});
		setPaymentTotal(0);
	}

	function showPayment() {
		let paymentBool = showPaymentModal;
		setShowPaymentModal(!paymentBool);
	}

	function viewDecision() {
		setShowDecisionModal(!showDecisionModal);
	}

	function closeDiscardPile() {
		setShowDiscardPileModal(false);
	}

	return (
		<>
			{showActionModal && (
				<ActionModal
					resetPaymentObject={resetPaymentObject}
					onClose={closeActionModal}
				/>
			)}

			{showSettingsModal && (
				<SettingsModal onClose={closeSettingsModal} />
			)}
			{showHandModal && (
				<HandModal
					onClose={closeHand}
					requestClientPayment={requestClientPayment}
					requestClientDecision={requestClientDecision}
					resetPaymentObject={resetPaymentObject}
				/>
			)}
			{showDiscardCardFromHandModal && (
				<DiscardCardFromHandModal
					onClose={closeDiscardCardFromHandModal}
				/>
			)}
			{/*showPaymentModal && (
				<PaymentModal
					onClose={closePayment}
					requestClientDecision={requestClientDecision}
					resetPaymentObject={resetPaymentObject}
				/>
			)*/}
			{showPaymentModal && (
				<PaymentAnimatedModal
					onClose={closePayment}
					requestClientDecision={requestClientDecision}
					resetPaymentObject={resetPaymentObject}
				/>
			)}
			{showDecisionModal && (
				<DecisionModal
					onClose={closeDecision}
					activeContractsAndAwards={myState?.activeContractsAndAwards}
					players={players}
				/>
			)}

			{showCardTableModal && (
				<CardsOnTableModal
					onClose={closeCardTable}
					currentPlayerId={currPlayer.playerId}
					equipmentAction={equipmentAction}
					cardsOnTablePlayerId={cardsOnTablePlayerId}
				/>
			)}
			{showDiscardPileModal && (
				<DiscardPileModal onClose={closeDiscardPile} />
			)}

			{showPlayermatModal && (
				<PlayermatModal
					playerMatPath={playerMatPath}
					onClose={closePlayermat}
				/>
			)}

			{showRulesmatModal && <RulesmatModal onClose={closeRulesmat} />}

			{showAdminStateModal && (
				<AdminStateModal onClose={closeAdminState} />
			)}

			{showNewsCardsModal && <NewsCardsModal onClose={viewNewsCards} />}

			{/* START On Player Turn Elements*/}
			{activePlayerId === currPlayer.playerId && (
				<>
					{!minimize && turnType === decisionTurnOrder && (
						<DecisionTurnOrderModal />
					)}
					{!minimize && turnType === decisionCardResolution && (
						<DecisionCardResolutionServerModal />
					)}
					{!minimize && turnType === decisionSummitDraft && (
						<DecisionSummitDraftModal />
					)}
					{!minimize && turnType === decisionSummitWinter && (
						<DecisionSummitWinterModal
							activeContractsAndAwards={
								myState?.activeContractsAndAwards
							}
							summitCards={myState?.summitCards}
						/>
					)}
				</>
			)}
			{/* END On Player Turn Elements */}
		</>
	);
};

export default ModalContainer;

// {/* At some point consider separate modals for these START */}

/* Builder */
// import ActiveContractsAndAwardsBuilder from '@/components/game/card3d/ActiveContractsAndAwardsBuilder';
// import CompletedContractsAndAwardsBuilder from '@/components/game/card3d/CompletedContractsAndAwardsBuilder';
// import EquipmentBuilder from '@/components/game/card3d/EquipmentBuilder';
// import FailedContractsBuilder from '@/components/game/card3d/FailedContractsBuilder';

// {showACA && (
//     <ActiveContractsAndAwardsBuilder onClose={setShowACA} />
// )}
// {showCCA && (
//     <CompletedContractsAndAwardsBuilder onClose={setShowCCA} />
// )}
// {showFC && <FailedContractsBuilder onClose={setShowFC} />}
// {showEquipment && (
//     <EquipmentBuilder onClose={setShowEquipment} />
// )}

// {/* At some point consider separate modals for these END */}
